


import TiwiMixin from '../../mixins/TiwiMixin'
import ProfileImagesUploadModal from './ProfileImagesUploadModal'

export default {
  mixins: [TiwiMixin],
  components: {
    ProfileImagesUploadModal
  },
  props: {
    currentImage: {
      required: false,
      default: false
    },
    updateBg: {
      required: false,
      default: false
    },
    updateSrc: {
      required: false,
      default: false
    },
    modalId: {
      required: false,
      default: false,
      type: String
    },
    isUserPicture: {
      required: false,
      default: false,
    }
  },
  data() {
    return {
      active: false,
    }
  },
  mounted: function () {
    // Eseguito al mount

    this.active = false;
  },
  computed: {

  },
  methods: {
    toggleActive: function () {
      if (!this.user?.ID)
        return;

      this.active = !this.active;
    },
    onModalClose: function () {
      this.active = false;
    },
    onModalSubmit: function (res, image_url) {
      if (this.updateBg) {
        document.querySelector(this.updateBg).style.backgroundImage = `url('${image_url}')`;
      }
      if (this.updateSrc) {
        document.querySelector(this.updateSrc).src = image_url;
      }
      this.active = false;
    }
  },
  watch: {

  }
}
